import React from 'react';

import { BreakPointName, CommonTheme, useCurrentTheme } from 'app/shared/theme';
import { useBreakpoint } from 'app/shared/utils';
import { makeOpaque } from 'app/shared/utils/colors';
import { Box, BoxProps } from 'app/shared/components/atoms';
import { BasePageBox } from 'app/shared/components/molecules';
import { DEFAULT_BASIC_HERO_IMAGE } from 'app/fan/utils/staticImages';

interface Props extends BoxProps {
  backgroundImage?: string | string[];
  grayscale?: boolean;
  children: React.ReactNode;
  'data-qaid'?: string;
}

const basicHeroAspectRatios: {
  [key in BreakPointName]: string;
} = {
  mobile: '1/1',
  tablet: '16/9',
  smallDesktop: '8/3',
  largeDesktop: '4/1',
};

export const BasicHero = ({
  backgroundImage,
  grayscale,
  children,
  ...props
}: Props) => {
  const { colors } = useCurrentTheme() as CommonTheme;
  const currentBreakpoint = useBreakpoint();

  const getBackgroundImage = () => {
    if (!backgroundImage || backgroundImage.length === 0) {
      return DEFAULT_BASIC_HERO_IMAGE;
    }

    if (Array.isArray(backgroundImage)) {
      return backgroundImage;
    }

    return `${backgroundImage}?ar=${basicHeroAspectRatios[currentBreakpoint].replace('/', ':')}`;
  };

  return (
    <Box
      aspectRatio={basicHeroAspectRatios[currentBreakpoint]}
      display="flex"
      backgroundImage={getBackgroundImage()}
      backgroundPosition="center"
      backgroundColor={makeOpaque(colors.primary.black.base, 0.5)}
      backgroundGrayscale={grayscale}
    >
      <BasePageBox {...props} h="100%">
        {children}
      </BasePageBox>
    </Box>
  );
};
